import React from "react";
import {MM_QUESTION} from "../../scripts/myga-model";
import PopoverTooltip from "../PopoverTooltip";
import {PROCESS_QUESTION_TEXT} from "../../scripts/layout-manager";

function QuestionCheckbox(props) {
  const {data, question, handleClick, required, responseClass} = props;
  const response = question.response[MM_QUESTION.response.constraints][0];

  return (
    <div className="form-check form-check-inline">
      <input
        required={required}
        type="checkbox"
        className={`form-check-input ${responseClass}`}
        id={question.key}
        checked={data[question.key]==='Yes'}
        onClick={handleClick(question.key)}
        onChange={() => {}}
      />
      <label className="form-check-label pl-2" htmlFor={question.key}>
        {PROCESS_QUESTION_TEXT(response)}
        {
          response.info && (
            <>
              &nbsp;
              <PopoverTooltip
                title={response.info.title}
                content={response.info.content} />
            </>
          )
        }
      </label>
    </div>
  );
}

export default QuestionCheckbox;